import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { Button } from '@mui/material'
import { Box } from '@mui/system'

import SubtractIcon from '~/assets/icons/FoodDetail/SubtractIcon'
import { THEMES_NAME } from '~/theme/constants'
import { ThemeContext } from '~/theme/ThemeProvider'
import AddIcon from '~/assets/icons/FoodDetail/AddIcon'
import { calcQuantityFoodOptionType, checkQuantityTopping } from '~/utils/foodDetail'
import { selectFoodOptionTypes, setQuantityFoodOption } from '../slices/itemDetailSlice'
import styles from '../styles/ControlToppingImage.module.scss'

import classNames from 'classnames/bind'
import useIsDesktop from '~/hooks/useIsDesktop'

const cx = classNames.bind(styles)

// Nút tăng giảm topping
const ControlToppingImage = ({
  id,
  min,
  max,
  minFoodOptionType,
  maxFoodOptionType,
  idFoodOptionType,
  is_topping_image,
}) => {
  const { currentThemeObject } = useContext(ThemeContext)
  const { colorText2, colorText1, colorText13 } = currentThemeObject
  const [quantity, setQuantity] = useState(1)
  const foodOptionTypes = useSelector(selectFoodOptionTypes)
  const dispatch = useDispatch()
  const isDesktop = useIsDesktop()

  useEffect(() => {
    if (min) setQuantity(min)
  }, [min])

  const onGetColorIconSubtract = () => {
    const showSubtract = min ? quantity > min : quantity > 1

    if (currentThemeObject.value === THEMES_NAME.red_bean) {
      return showSubtract ? colorText1 : colorText2
    }
    return showSubtract ? colorText2 : colorText1
  }

  const onGetColorIconAdd = () => {
    return currentThemeObject.value === THEMES_NAME.red_bean ? colorText1 : colorText2
  }

  const onGetBackgroundBtnQuantity = () => {
    return currentThemeObject.value === THEMES_NAME.red_bean ? colorText2 : colorText1
  }

  const handleChangeQuantity = (isAdded) => {
    if (isAdded) {
      const isInvalidQuantity = checkQuantityTopping({
        quantity,
        min,
        max,
        minFoodOptionType,
        maxFoodOptionType,
        totalQuantityFoodOptionType: calcQuantityFoodOptionType(foodOptionTypes, idFoodOptionType),
      })

      if (isInvalidQuantity) return
    } else {
      if (quantity <= min || quantity <= 1) return
    }

    const newQuantity = isAdded ? quantity + 1 : quantity - 1

    setQuantity(newQuantity)

    // Xử lý lưu trên redux
    dispatch(
      setQuantityFoodOption({
        quantity: newQuantity,
        foodOptionId: id,
        foodOptionTypeId: idFoodOptionType,
      }),
    )
  }

  const sizeIcon = '15px'

  return (
    <div className={cx('controls_wrapper', { is_topping_image })}>
      <Box
        component="div"
        className={cx('controls')}
        style={{
          backgroundColor: onGetBackgroundBtnQuantity(),
        }}>
        <Button
          className={cx('control_btn')}
          onClick={() => handleChangeQuantity(false)}
          style={{
            backgroundColor: onGetBackgroundBtnQuantity(),
          }}>
          <SubtractIcon size={sizeIcon} color={onGetColorIconSubtract()} />
        </Button>
        <Box
          component="span"
          className={cx('number_quantity')}
          style={{
            color: colorText13,
          }}>
          {quantity || 1}
        </Box>
        <Button className={cx('control_btn')} onClick={() => handleChangeQuantity(true)}>
          <AddIcon size={sizeIcon} color={onGetColorIconAdd()} />
        </Button>
      </Box>
    </div>
  )
}

ControlToppingImage.propTypes = {
  id: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  minFoodOptionType: PropTypes.number,
  maxFoodOptionType: PropTypes.number,
  required: PropTypes.bool,
  idFoodOptionType: PropTypes.number,
  is_topping_image: PropTypes.bool,
}

export default React.memo(ControlToppingImage)
